import { getAutoResponseMailText, getNotificationMailText } from './mailText';

// メール送信APIの認証情報
const user = process.env.API_AUTH_USER;
const password = process.env.API_AUTH_PASSWORD;

// 入力情報の取得
const getFormData = () => {
  const fullname = document.getElementById('contact-name').value;
  const company = document.getElementById('contact-company').value;
  const department = document.getElementById('contact-department').value;
  const email = document.getElementById('contact-email').value;
  const tel = document.getElementById('contact-tel').value;
  const body = document.getElementById('contact-body').value;

  return {
    fullname: fullname,
    company: company,
    department: department,
    email: email,
    tel: tel,
    body: body
  };
};

// 入力データのバリデーション（戻り値: boolean）
const formValidation = (formData) => {
  const { fullname, company, department, email, tel, body } = formData;

  // 状態をリセット
  document.querySelector('#error-fullname').dataset.isShow = 'false';
  document.querySelector('#error-company').dataset.isShow = 'false';
  document.querySelector('#error-department').dataset.isShow = 'false';
  document.querySelector('#error-email').dataset.isShow = 'false';
  document.querySelector('#error-tel').dataset.isShow = 'false';
  document.querySelector('#error-body').dataset.isShow = 'false';

  // バリデーションチェック用のフラグ
  let checkFormData = true;

  // メールアドレス確認用の正規表現
  const emailRegex = new RegExp(
    '^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*.)+[a-zA-Z]{2,}$'
  );

  if (!fullname) {
    document.querySelector('#error-fullname').dataset.isShow = 'true';
    checkFormData = false;
  }
  if (!company) {
    document.querySelector('#error-company').dataset.isShow = 'true';
    checkFormData = false;
  }
  if (!department) {
    document.querySelector('#error-department').dataset.isShow = 'true';
    checkFormData = false;
  }
  if (!email || !emailRegex.test(email)) {
    document.querySelector('#error-email').dataset.isShow = 'true';
    checkFormData = false;
  }
  if (!tel) {
    document.querySelector('#error-tel').dataset.isShow = 'true';
    checkFormData = false;
  }
  if (!body) {
    document.querySelector('#error-body').dataset.isShow = 'true';
    checkFormData = false;
  }

  return checkFormData;
};

// 自動返信メール送信
const sendAutoResponseMail = async (formData) => {
  if (!user || !password) return;

  const { email } = formData;

  // メール送信
  await fetch(process.env.MAIL_API_ENDPOINT, {
    method: 'POST',
    headers: {
      Authorization: `Basic ${btoa(`${user}:${password}`)}`
    },
    body: JSON.stringify({
      from: process.env.MAIL_ADDRESS,
      to: email,
      subject: 'お問い合わせを受け付けました',
      text: getAutoResponseMailText(formData)
    })
  })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
};

// 通知メール送信
const sendNotificationMail = async (formData) => {
  if (!user || !password) return;

  // メール送信
  await fetch(process.env.MAIL_API_ENDPOINT, {
    method: 'POST',
    headers: {
      Authorization: `Basic ${btoa(`${user}:${password}`)}`
    },
    body: JSON.stringify({
      from: 'E-biss Factory サービスサイト',
      to: process.env.MAIL_ADDRESS,
      subject: '【E-Biss Factory】お問い合わせを受信しました',
      text: getNotificationMailText(formData)
    })
  })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
};

// submit buttonの無効化
const invalidateSubmitButton = () => {
  const buttonElem = document.getElementById('submit-button');
  buttonElem.disabled = true;
  buttonElem.value = '送信中...';
};

const onSubmit = async () => {
  // フォームデータの取得
  const formData = getFormData();

  // 入力内容のチェック
  if (formValidation(formData)) {
    invalidateSubmitButton(); // 複数回クリック対策
    await sendAutoResponseMail(formData); // 自動返信メール送信
    await sendNotificationMail(formData); // お問い合わせ通知メール送信
    window.location.href = '/complete.html'; // 完了ページにリダイレクト
  } else {
    document.getElementById('submit-button').disabled = false;
    window.scrollTo({ top: 0 });
  }
};

document.getElementById('submit-button').addEventListener('click', onSubmit);
